var cartButtons = document.querySelectorAll("[data-cart-btn]")

window.addEventListener("load", () => {
    cartButtons.forEach(button => {
        button.addEventListener("click", () => {
            shoppingCartButtons(button)
        })
    })
})

shoppingCartCounts.forEach(cartCount => {
    if(cartCount.classList.contains("hidden") && cartCount.innerHTML != "")
        cartCount.classList.remove("hidden")
})

function updateShoppingCartCount() {
    shoppingCartCounts.forEach(shoppingCartCount => {
    if(shoppingCartCount.innerHTML != "" || shoppingCartCount.innerHTML != "0" && shoppingCartCount.classList.contains("hidden")) {
        shoppingCartCount.classList.remove("hidden")
    } 
    
    if(shoppingCartCount.innerHTML == "0" || shoppingCartCount.innerHTML == "") {
        shoppingCartCount.classList.add("hidden")
    }
    })
}

function updateShoppingCart() {
    if(cartCount != 0)
        updateButtons()
}

function updateButtons() {
    cartButtons = document.querySelectorAll("[data-cart-btn]")
    cartButtons.forEach(button => {
        button.addEventListener("click", () => {
            shoppingCartButtons(button)
        })
    })
}

function shoppingCartButtons(button) {
    let btnName = button.getAttribute("data-cart-btn")
    if(btnName === "trash") {
        trashButtonsDelete(button)
    } else if(btnName === "decrease") {
        let itemKey = button.getAttribute("data-item-key")
        var increaseBtn = document.querySelector(`[data-cart-quantity-btn='increase_${itemKey}']`)
        let inputField = document.querySelector(`[data-cart-input='${itemKey}']`)

        if(inputField.value > 0)
            inputField.value -= 1

        if(inputField.value == 0) 
            button.disabled = true

        if(increaseBtn.disabled)
            increaseBtn.disabled = false
    } else if(btnName === "increase") {
        let itemKey = button.getAttribute("data-item-key")
        var decreaseBtn = document.querySelector(`[data-cart-quantity-btn='decrease_${itemKey}']`)
        let inputField = document.querySelector(`[data-cart-input='${itemKey}']`)
        
        if(inputField.value < 99)
            inputField.value = parseInt(inputField.value) + 1

        if(inputField.value == 99)
            button.disabled = true

        if(decreaseBtn.disabled)
            decreaseBtn.disabled = false
    } else if(btnName === "update") {
        let itemKey = button.getAttribute("data-item-key")
        let itemID = button.getAttribute("data-item-id")
        let inputValue = parseInt(document.querySelector(`[data-cart-input='${itemKey}']`).value)

        updateButton(button)
    } else if(btnName === "clear") {
        clearButton()
    }
}

function trashButtonsDelete(button) {    
    let itemID = parseInt(button.getAttribute("data-item-id"))
    let itemQuantity = parseInt(button.getAttribute("data-item-quantity"))

    Shopify.removeItem(itemID)

    setTimeout(() => {
        cartCount -= itemQuantity
        shoppingCartCounts.forEach(shoppingCartCount => {
            shoppingCartCount.innerHTML = cartCount
        })
        updateShoppingCartCount()
        $('[data-shopping-cart-content]').load(location.href+' [data-shopping-cart-content]>*',function() {
            updateShoppingCart()
        })
    }, 1000)
}

function updateButton(button) {
    let quantityCount
    let itemID = parseInt(button.getAttribute("data-item-id"))
    let itemKey = button.getAttribute("data-item-key")
    let itemQuantity = parseInt(button.getAttribute("data-item-quantity"))
    let inputValue = parseInt(document.querySelector(`[data-cart-input='${itemKey}']`).value)

    quantityCount = inputValue - itemQuantity

    itemQuantity += quantityCount
    button.setAttribute("data-item-quantity", `${itemQuantity}`)

    Shopify.changeItem(itemID, itemQuantity)
    

    setTimeout(() => {
        cartCount += quantityCount
        shoppingCartCounts.forEach(shoppingCartCount => {
            if(cartCount > 99)
                shoppingCartCount.innerHTML = "99+"
            else
                shoppingCartCount.innerHTML = cartCount
        })
        updateShoppingCartCount()
        $('[data-shopping-cart-content]').load(location.href+' [data-shopping-cart-content]>*',function() {
            updateShoppingCart()
        })
    }, 1000)
}

function clearButton() {
    Shopify.clear()

    setTimeout(() => {
        cartCount = 0
        shoppingCartCounts.forEach(shoppingCartCount => {
            shoppingCartCount.innerHTML = cartCount
        })
        updateShoppingCartCount()
        $('[data-shopping-cart-content]').load(location.href+' [data-shopping-cart-content]>*',"")
    }, 1000)
}

function getCartJSON() {
    let temp = $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        async: false,
    }).responseJSON

    return temp
}

const checkOutButton = document.querySelector('.quantity-btn.cart-total-btn[type="submit"]')

if(checkOutButton != null) {
    checkOutButton.addEventListener("click", async function(event) {
        event.preventDefault()
        if(await cartVendorCheck("PDC Healthcare"))
            Shopify.updateCartAttributes("pdc-healthcare", "Verify if order is shipping separately.")
        else Shopify.clearCartAttributes()
        document.checkoutSlide.submit()
        window.location.href = `/checkouts/cn/${await Shopify.getCartToken()}`
    })
}

async function cartVendorCheck(vendorName) {
    const request = new Request('/cart.json', {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    })

    let vendors = []

    const response = await fetch(request)
    const cartItems = (await response.json()).items
    cartItems.forEach(item => {
        vendors.push(item.vendor)
    })
    if(vendors.includes(vendorName)) return true
    else return false
}